import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { UserAccountQuery } from '../store/userAccount/user-account.query';
import { VendorQuery } from '../store/vendor/vendor.query';

@Injectable({
    providedIn: 'root',
})
export class NetworkGuard  {
    private _router = inject(Router);
    private _userAccountQuery = inject(UserAccountQuery);
    private _vendorQuery = inject(VendorQuery);

    public canActivate(): boolean {
        const isOfficialSustainmentAccount = this._vendorQuery.getValue().vendor.isOfficialSustainmentAccount;
        const hasNetworkTabAccess = this._userAccountQuery.hasNetworkTabAccess;
        
        const canActivate = hasNetworkTabAccess || isOfficialSustainmentAccount;

        if (!canActivate) this._router.navigate(['/']);

        return canActivate;
    }
}
